/** httpOnly cookie that holds the FastAPI admin JWT (frontend origin). */
export const ADMIN_TOKEN_COOKIE = "admin_token";

/** Double-submit CSRF cookie (readable by JS; paired with X-Admin-CSRF header). */
export const ADMIN_CSRF_COOKIE = "admin_csrf";

/**
 * Client-side sentinel so existing `if (!token)` guards still pass when the
 * real JWT lives only in an httpOnly cookie (non-mock mode).
 */
export const ADMIN_COOKIE_SESSION_MARKER = "cookie-session";

/** Match backend JWT_EXPIRES_MINUTES default (240). */
export const ADMIN_SESSION_MAX_AGE = 60 * 60 * 4;

export function adminCookieOptions(maxAgeSeconds: number) {
  return {
    httpOnly: true,
    secure: process.env.NODE_ENV === "production",
    sameSite: "lax" as const,
    path: "/",
    maxAge: maxAgeSeconds,
  };
}

export function adminCsrfCookieOptions(maxAgeSeconds: number) {
  return {
    httpOnly: false,
    secure: process.env.NODE_ENV === "production",
    sameSite: "lax" as const,
    path: "/",
    maxAge: maxAgeSeconds,
  };
}
